/**
 * 從主選單中取得自訂資料
 * @param {Array} mainMenu - 主選單陣列
 * @param {string} locale - 當前語系
 * @param {string} type - 選單項目類型
 * @param {Function} [getCdnUrl] - CDN 路徑轉換函數
 * @returns {Object} 包含 name 和 image 的物件
 */
export const getCustomizedMenuItem = (mainMenu, locale, type, getCdnUrl) => {
  const foundItem = (mainMenu || []).find((el) => el.item === type)
  const { appIconUrl, nameI18n } = foundItem || {}

  let imageUrl = appIconUrl?.[0]?.url
  if (getCdnUrl && imageUrl) {
    imageUrl = getCdnUrl(imageUrl) || imageUrl
  }

  return {
    name: nameI18n?.[locale] ? nameI18n[locale] : nameI18n?.['en-US'],
    image: imageUrl,
  }
}
